const isEqual = require('lodash').isEqual;
/**
 * Return an object containing the params from second that exist in
 * first, but values are different
 *
 * @param  {[type]} first:  Object        [description]
 * @param  {[type]} second: Object        [description]
 * @return {[type]}         [description]
 */


module.exports = (first
/*: Object*/
, second
/*: Object*/
) => {
  const diff
  /*: Object*/
  = {};
  Object.keys(first).forEach(key => {
    if (second[key] === undefined) return;
    if (isEqual(second[key], first[key])) return;
    diff[key] = second[key];
  });
  return diff;
};